// File Path: frontend/src/component/Documents/DocumentViewerModal.jsx
import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  alpha,
  Portal
} from '@mui/material';
import {
  Close as CloseIcon,
  PictureAsPdf as PdfIcon,
  Image as ImageIcon
} from '@mui/icons-material';

const DocumentViewerModal = ({ viewingDocUrl, onClose }) => {
  const theme = useTheme();

  if (!viewingDocUrl) return null;

  const isPdf = viewingDocUrl.toLowerCase().includes('.pdf');

  return (
    <Portal>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 1300,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: alpha('#0f172a', 0.7),
          backdropFilter: 'blur(4px)',
          p: { xs: 2, sm: 3 }
        }}
        onClick={onClose}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: '1200px',
            bgcolor: 'background.paper',
            borderRadius: 3,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '90vh',
            boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.05)'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 3,
              py: 2,
              borderBottom: '1px solid #f1f5f9',
              bgcolor: alpha('#f8fafc', 0.8)
            }}
          >
            <Typography
              variant="h6"
              component="h3"
              sx={{
                fontWeight: 700,
                color: '#1e293b',
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              {isPdf ? <PdfIcon sx={{ color: '#ef4444' }} /> : <ImageIcon sx={{ color: '#3b82f6' }} />}
              Document Viewer
            </Typography>
            <IconButton
              onClick={onClose}
              size="small"
              sx={{
                color: '#94a3b8',
                transition: 'all 0.2s',
                '&:hover': {
                  color: '#ef4444',
                  bgcolor: alpha('#fef2f2', 0.8)
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              bgcolor: alpha('#cbd5e1', 0.3),
              p: { xs: 2, sm: 4 },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '50vh'
            }}
          >
            {isPdf ? (
              <Box
                component="iframe"
                src={viewingDocUrl}
                sx={{
                  width: '100%',
                  height: { xs: '50vh', sm: '70vh' },
                  border: '1px solid #e2e8f0',
                  borderRadius: 2,
                  boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
                  bgcolor: 'white'
                }}
                title="PDF Viewer"
              />
            ) : (
              <Box
                component="img"
                src={viewingDocUrl}
                alt="Document Preview"
                sx={{
                  maxWidth: '100%',
                  maxHeight: { xs: '60vh', sm: '75vh' },
                  objectFit: 'contain',
                  borderRadius: 2,
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.05)',
                  bgcolor: 'white'
                }}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Portal>
  );
};

export default DocumentViewerModal;